import {svgIconWrapper} from '../svg-icon-wrapper';

import ParentCompany from './parent-company-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ParentCompany {...validProps} />;
}

SvgComponent.iconName = 'parent-company';

export const ParentCompanyIcon = svgIconWrapper(SvgComponent);
